var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField, useFormikContext } from 'formik';
export function RemoveSelection() {
    const { submitForm } = useFormikContext();
    const [, meta, helpers] = useField('value');
    const hasPair = Boolean(meta.initialValue !== '' && meta.initialValue != null);
    const handleRemove = () => __awaiter(this, void 0, void 0, function* () {
        helpers.setValue(undefined);
        return submitForm();
    });
    if (!hasPair) {
        return null;
    }
    return (<Menu.Item onClick={handleRemove}>
      <Falcon icon="trash"/>
      <Trans comment="Add Metadata Pair: Filesystem reference - Save value button">Remove</Trans>
    </Menu.Item>);
}
